export const isNewClient = (client) => Boolean(
  client?.extra?.isNew ?? client?.extra?.new
);

export const isVipClient = (client) => Boolean(client?.vip);

export const isInternalHotelClient = (booking) => Boolean(
  booking?.client?.roles?.some((role) => role.name !== 'ROLE_CLIENT')
);

export const isHotelRoomBooking = (booking) => booking?.room_type === 'HOTEL_ROOM';

export const getHotelClientBadgeLabel = (booking, translate) => {
  const internal = isInternalHotelClient(booking);

  if (isHotelRoomBooking(booking)) {
    return internal ? 'INT.' : 'EXT.';
  }

  return internal ? translate('internal') : translate('external');
};

export const getClientBookingsCount = (client) => {
  const count = client?.bookings_count
    ?? client?.booking_count
    ?? client?.extra?.bookings_count
    ?? client?.extra?.booking_count;

  if (count !== undefined && count !== null && count !== '') {
    const numericCount = Number(count);
    return Number.isFinite(numericCount) ? numericCount : null;
  }

  return Array.isArray(client?.bookings) ? client.bookings.length : null;
};

export const formatClientNameWithCount = (client, fallbackName = '') => {
  const name = client?.extra?.full_name || fallbackName;
  const count = getClientBookingsCount(client);

  return count === null ? name : `${name} (${count})`;
};
